/** Formatos de fecha y hora del panel, siempre en español rioplatense. */

export function formatDate(isoDate: string): string {
  const [year, month, day] = isoDate.split('-')
  return `${day}/${month}/${year}`
}

export function formatTime(iso: string | null): string {
  if (!iso) return '—'
  return new Date(iso).toLocaleTimeString('es-AR', { hour: '2-digit', minute: '2-digit' })
}

/** Minutos a "8 h 15 m", que es como se leen las jornadas. */
export function formatDuration(minutes: number): string {
  if (minutes <= 0) return '—'

  const hours = Math.floor(minutes / 60)
  const rest = minutes % 60

  if (hours === 0) return `${rest} m`
  if (rest === 0) return `${hours} h`

  return `${hours} h ${rest} m`
}

/** "hace 2 min", para indicar cuán fresco es lo que se está viendo. */
export function formatRelative(from: Date, now: Date = new Date()): string {
  const seconds = Math.floor((now.getTime() - from.getTime()) / 1000)

  if (seconds < 10) return 'recién'
  if (seconds < 60) return `hace ${seconds} s`

  const minutes = Math.floor(seconds / 60)
  if (minutes < 60) return `hace ${minutes} min`

  const hours = Math.floor(minutes / 60)
  return `hace ${hours} h`
}
